import React, { Suspense } from 'react'

import StyledAdminWrapper from './StyledAdminWrapper'
import ManageContent from 'components_v2/Admin/Engagement/ManageContent'

const EngagementManagerWrapper = (props) => (
  <StyledAdminWrapper>
    <Suspense fallback=''>
      <ManageContent {...props} />
    </Suspense>
  </StyledAdminWrapper>
)

export default EngagementManagerWrapper
